export default __webpack_public_path__ + "static/media/bb2.d487775d.png";